var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bonus)?_c('div',{staticClass:"bonus-rule"},[(_vm.lang=='ru')?_c('ru',{attrs:{"bonus":_vm.bonus}}):(_vm.lang=='fr')?_c('fr',{attrs:{"bonus":_vm.bonus}}):(_vm.lang=='es')?_c('es',{attrs:{"bonus":_vm.bonus}}):_c('en',{attrs:{"bonus":_vm.bonus}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-coupon/index.vue?vue&type=template&id=05025469
// module id = gPA7
// module chunks = 0